import { useMutation } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import TwilioVerificationService from 'src/features/verification/data/service/TwilioVerificationService';
import { useNavigate } from 'react-router-dom';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { Session } from 'src/types/common';

const twilioService = diContainer.get<TwilioVerificationService>(
  TwilioVerificationService
);

export const useAuthenticationOtpMutations = () => {
  const navigate = useNavigate();
  const { setSession } = useAuthContext();

  const verifyLoginOtpMutation = useMutation({
    mutationFn: async ({
      phone_number,
      code,
      type,
    }: {
      phone_number: string;
      email?: string;
      code: string;
      type: 'AUTHENTICATION';
    }) => {
      return twilioService.verifyLoginOtp({
        phone_number,
        code,
        type,
      });
    },
    onSuccess: (response) => {
      if (response.data) {
        const session: Session = {
          accessToken: response.data.access_token,
          user: response.data.user,
        };
        setSession(session);
        navigate('/specialized-stores/products');
      }
    },
  });

  const sendLoginOtpMutation = useMutation({
    mutationFn: async ({
      phone_number,
      email,
      type,
    }: {
      phone_number: string;
      email?: string;
      type: 'AUTHENTICATION';
    }) => {
      return twilioService.sendLoginOtp({
        type,
        phone_number,
        email,
      });
    },
  });

  return { verifyLoginOtpMutation, sendLoginOtpMutation };
};
